/*
  QTS Binding Library
  This includes functions for binding qts pushing to events, as follows:
  init()
  - initializes default values for all qts events
    this may set two separate default values for the navbar and for the page
    push()
  - used for js process events, not directly w/ user interaction
    bind()
  - bind to an element click event.
    if contains a link, it shall prevent & setTimeout to allow qts pixel
    request, before redirecting.
*/

import jq from 'jquery';

// general container for all qtsbinds data;
const qtsv = {
  timeout: false,
  defaults: {},
  page: {},
  nav: {},
};

qtsv.defaults = {
  pageContainer: '.gaf-container:first',
  navContainer: '.header-and-nav',
};

const setDefault = (params, isNav) => {
  if (typeof isNav === 'boolean' && isNav) {
    if (params) {
      Object.keys(params).forEach((pkey) => {
        qtsv.nav[pkey] = params[pkey];
      });
    }
  } else if (params) {
    Object.keys(params).forEach((pkey) => {
      qtsv.page[pkey] = params[pkey];
    });
  }
  qtsv.timeout = false;
};

const push = (params, url, isNav) => {
  const qvars = qtsv;
  if (!qvars.timeout) {
    const paramSet = typeof isNav === 'undefined' ?
      JSON.parse(JSON.stringify(qvars.page)) :
      JSON.parse(JSON.stringify(qvars.nav));

    if (typeof params === 'object') {
      if (params) {
        Object.keys(params).forEach((pkey) => {
          if (pkey != 'eventName') {
            paramSet[pkey] = params[pkey];
          }
        });
      }
    } else if (typeof params === 'string') {
      paramSet.label = params;
    }

    if (typeof params.eventName !== 'undefined') {
      _t.push([params.eventName, paramSet]);
    } else {
      _t.push(['user_action', paramSet]);
    }


    setTimeout(() => {
      if (typeof url === 'string') {
        window.location = url;
      }
    }, 1000);

    setTimeout(() => {
      qvars.timeout = false;
    }, 100);

    qvars.timeout = true;
  }
};

const createBind = (ifselector, params, isNav) => {
  const qvars = qtsv;

  params = params || {};

  let containerEl = qvars.defaults.pageContainer;
  let selector = '[data-qts]';

  if (typeof ifselector === 'string') {
    selector = ifselector;
  } else if (typeof ifselector === 'object') {
    selector = ifselector.id;
    // attach conditional values to element so it won't be lost after binding
    jq(selector).attr('data-qtcon', ifselector.con);
    jq(selector).attr('data-qt0', ifselector.falsy);
    jq(selector).attr('data-qt1', ifselector.truthy);
  }

  if (typeof isNav === 'string') {
    containerEl = isNav;
  } else if (typeof isNav === 'boolean' && isNav == true) {
    containerEl = qvars.defaults.navContainer;
  }

  jq(containerEl).on('click', selector, (e) => {
    e.preventDefault();
    // if navbar is a link, assign triggerable flag so it can be triggered after
    // qts is pushed.
    const paramSet = typeof isNav === 'undefined' ?
      JSON.parse(JSON.stringify(qvars.page)) :
      JSON.parse(JSON.stringify(qvars.nav));

    const thisEl = jq(e.currentTarget);
    let triggerable = false;
    if (typeof thisEl.attr('href') !== 'undefined') {
      triggerable = true;
    }

    if (!qtsv.timeout) {
      if (params) {
        Object.keys(params).forEach((pkey) => {
          if (pkey != 'eventName') {
            paramSet[pkey] = params[pkey];
          }
        });
      }

      const label = thisEl.data('qts');

      if (typeof label !== 'undefined') {
        paramSet.label = label;
      }

      // for conditional selectors
      const hasCondition = typeof thisEl.data('qtcon') !== 'undefined';

      if (hasCondition) {
        // toggle text value (qt1 or qt0) depending on condition (qtcon)
        if (thisEl.data('qtcon') == false) {
          paramSet.label = thisEl.data('qt1');
          thisEl.data('qtcon', true);
        } else {
          paramSet.label = thisEl.data('qt0');
          thisEl.data('qtcon', false);
        }
      }

      if (typeof paramSet.action === 'undefined') {
        paramSet.action = 'click';
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _lt.push(['user_action', paramSet]);
      }

      // sets a timeout fxn & timer to measure if qts push taking too long.
      qtsv.timer = setTimeout(() => {
        qtsv.timeout = false;
        if (triggerable) {
          window.location = thisEl.attr('href');
        }
      }, 1000);

      qtsv.timeout = true;
      qtsv.timerRun = 0;
    }
  });
};

qtsv.push = push;

export const qtsp = {
  init: setDefault,
  bind: createBind,
  push,
};
